module.exports = __webpack_public_path__ + "assets/img/illust_02_large.509fd3b0.png";